import { ArrayOpType } from '@tencent/slide-sdk-pb-model';
import { SetThemeMutation } from '../mutation/theme/set-theme-mutation';
import { Rule } from '../mutation/base/mutation-rules';
import { record } from '../utils/recorder';
import { merge } from '../utils/protoutil';
import { cloneDeep } from '../utils/clone-deep';
import { MutationAPI } from './mutation-api';
import type { IEventManager } from '../manager/event-manager';
import type { DeltaOf } from '../utils/delta';
import type { ThemeDataModel } from '../model/theme-data-model';
import type { ICTBaseStyles, ICTBaseStylesDelta } from '@tencent/slide-sdk-pb-model';

export class ThemeMutationAPI extends MutationAPI<ThemeDataModel> {
    public constructor(public model: ThemeDataModel, events: IEventManager) {
        super(model, events);
    }

    /**
     * 更新主题字体
     *
     * 对于多语言主题，只更新汉字字体
     * @param newFont 新字体
     * @param importance 确定更新哪一重要性级别的字体：major 或 minor
     */
    @record()
    public updateThemeFontFamily(newFont: string, importance: 'major' | 'minor') {
        const indexOfHans = this.model.props.themeElements?.fontScheme?.[`${importance}Font`]?.font?.findIndex(
            (fontItem) => fontItem.script === 'Hans',
        );
        const operateType = indexOfHans === undefined || indexOfHans < 0 ? ArrayOpType.Append : ArrayOpType.Modify;
        const themeData: ICTBaseStylesDelta = {
            fontScheme: {
                [`${importance}Font`]: {
                    latin: { typeface: newFont },
                    ea: { typeface: '' },
                    font: [{ script: 'Hans', typeface: newFont }],
                    fontOp: { opType: operateType, opIndex: indexOfHans },
                },
            },
        };
        this.updateTheme(themeData);
    }

    /**
     * 更新主题
     * @param themeData 待更新的信息
     */
    @record()
    public updateTheme(themeData: DeltaOf<ICTBaseStyles>, name?: string) {
        this.guard((presentation) => Rule.theme.should.existInPresentation(presentation, this.model.id));

        this.transaction(() => {
            this.request([
                new SetThemeMutation({
                    themeId: this.model.id,
                    themeName: name ?? this.model.props.name ?? '',
                    themeElements: themeData && merge(cloneDeep(this.model.store.data.themeElements), themeData),
                }),
            ]);
        });
    }
}
